
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import BatchIndexModule from "@/store/modules/batchIndex";

import draggable from "vuedraggable";
import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { IDocumentBatch } from "@/store/types";
import notifications from "@/lib/notifications";
import { stringify } from "qs";


@Component({
  components: {
    RightClickMenu
  }
})

export default class DocumentBatches extends Vue {
    batchIndexModule = getModule(BatchIndexModule);
    menuItems: any[] = [];
    rightClickLocation: any = null;
    facilityCode: string = "";     
    batches: IDocumentBatch[] = [];
    selectedBatch: IDocumentBatch = null;
    showCancelModal: boolean = false;

    async clickMenu(item) {
        this.rightClickLocation = null;

        if (!this.selectedBatch) return;
        this.showCancelModal = true;
    }   
    
    async mounted () {
        this.facilityCode = this.batchIndexModule.facilityCode;
        this.batches = await this.loadData();
        this.buildContextMenu();
    }

    async loadData(): Promise<IDocumentBatch[]>  {
        try {
            var payload = { 
                facility: this.facilityCode ?? "", 
                taskId: 1, 
                workItemStatus: 0 
            };
            return await this.batchIndexModule.getBatchTaskWorkItems(payload)
                .then(result =>  {
                    return result.data.batches;
                })
                .catch((error) => {
                    notifications.error("Load Failed", "Unable to load image.", error);
                })
        } catch (ex) {
            notifications.error("Loading Failed", "Unable to load batches.", ex);
        } 
    }

    clearRightClick() {
        this.rightClickLocation = null;
    }

    getRowClass(batch: IDocumentBatch) {
        return batch.id === this.selectedBatch?.id ? "selected" : "";
    }

    onRowClicked(batch: IDocumentBatch) {
        this.selectedBatch = batch;
        this.clearRightClick();
    }

    onRowDoubleClicked(batch: IDocumentBatch) {
        this.$router.push(`/dms/batch/${batch.workItemId}`);
    }

    onRightClicked(batch: IDocumentBatch, event: any) {
        event.preventDefault();

        if (batch?.lockedBy) {
            this.selectedBatch = batch;
            this.rightClickLocation = { x: event.x, y: event.y };
        }
    }    

    getLockedView(batch: IDocumentBatch) {
        if (!batch?.lockedBy) return "";
        return '<i class="fas fa-lock"></i>';
    }

    async onRefreshButtonClicked() {
        this.batches = await this.loadData(); 
    }

    @Watch('facilityCode')
    async watchFacilityCode(value: string) {
        this.batchIndexModule.setFacilityCode(value);
        this.batches = await this.loadData(); 
    }

    buildContextMenu() {
        this.menuItems.length = 0;
        this.menuItems.push(
        {
            title: "Cancel Batch",
            name: "cancel",
            action: "cancelBatch",
        });
    }

    async cancelAccept() {
        this.showCancelModal = false;

        let payload = {
            id: this.selectedBatch.workItemId,
            batch: this.selectedBatch,
            unlockBatch: true,
            targetQueueId: null
        }

        await this.batchIndexModule.putBatchTaskWorkItem(payload)
            .then(result =>  {
                notifications.success("Batch Canceled", "Batch has been canceled and unlocked.")
            })
            .catch((error) => {
                notifications.error("Cancel Failed", "Unable to cancel batch.", error);
            })

        this.batches = await this.loadData();             
    }

    cancelCancel() {
        this.showCancelModal = false;
    }    
}
